<template>
  <div>
    <div class="xl:hidden absolute top-0 left-0 flex items-center gap-2 w-full" style="background: #fafafa" @click="$router.go(-1)">
      <img src="@/assets/icons/arrow_left_black.svg" />
      <h2 style="color: #3c3c3c">{{ getTitle }}</h2>
    </div>

    <component :is="getComponent" :comGroupList="comGroupList" />
  </div>
</template>

<script>
import ComparisonBarGraph from "@/components/ComparisonBarGraph";
import TableListPage from "@/views/list/TableListPage";
import BasicBarGraph from "@/components/BasicBarGraph";
import KPagination from "@/components/kPagination/kPagination";
import DateSelector from "@/components/selector/DateSelector";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";

export default {
  name: "Index",
  components: {
    SearchNavItemSelect,
    DateSelector,
    KPagination,
    BasicBarGraph,
    TableListPage,
    ComparisonBarGraph,
    GraphDetailNone: () => import("@/views/graph-detail/GraphDetailNone"),
    GraphDetail01: () => import("@/views/graph-detail/GraphDetail01"),
    GraphDetail02: () => import("@/views/graph-detail/GraphDetail02"),
    GraphDetail03: () => import("@/views/graph-detail/GraphDetail03"),
    GraphDetail04: () => import("@/views/graph-detail/GraphDetail04"),
    GraphDetail05: () => import("@/views/graph-detail/GraphDetail05"),
    GraphDetail06: () => import("@/views/graph-detail/GraphDetail06"),
    GraphDetail07: () => import("@/views/graph-detail/GraphDetail07"),
    GraphDetail08: () => import("@/views/graph-detail/GraphDetail08"),
    GraphDetail09: () => import("@/views/graph-detail/GraphDetail09"),
    GraphDetail10: () => import("@/views/graph-detail/GraphDetail10"),
    GraphDetail11: () => import("@/views/graph-detail/GraphDetail11"),
    GraphDetail12: () => import("@/views/graph-detail/GraphDetail12"),
    GraphDetail13: () => import("@/views/graph-detail/GraphDetail13"),
    GraphDetail14: () => import("@/views/graph-detail/GraphDetail14"),
    GraphDetail15: () => import("@/views/graph-detail/GraphDetail15"),
    GraphDetail16: () => import("@/views/graph-detail/GraphDetail16"),
    GraphDetail17: () => import("@/views/graph-detail/GraphDetail17"),
    GraphDetail18: () => import("@/views/graph-detail/GraphDetail18"),
    GraphDetail19: () => import("@/views/graph-detail/GraphDetail19"),
    GraphDetail20: () => import("@/views/graph-detail/GraphDetail20"),
    GraphDetail37: () => import("@/views/graph-detail/GraphDetail37"),
    GraphDetail1000: () => import("@/views/graph-detail/GraphDetail1000"),
    GraphDetail999: () => import("@/views/graph-detail/GraphDetail999"),

    GraphDetailHealthSafetyInspectionNotPerformedChart: () => import("@/views/graph-detail/GraphDetailHealthSafetyInspectionNotPerformedChart"),
    GraphDetailHealthSafetyEducationNotPerformedChart: () => import("@/views/graph-detail/GraphDetailHealthSafetyEducationNotPerformedChart"),
    GraphDetailHSImplementationStatus: () => import("@/views/graph-detail/GraphDetailHSImplementationStatus"),
  },
  data() {
    return {};
  },
  async created() {
    await this.loadCompanyList();
  },
  async mounted() {},
  computed: {
    getTitle() {
      const nId = this.graphId;
      switch (nId) {
      case '1': return '사업장 현황';
      case '2': return '종사자 현황';
      case '3': return '산업안전보건위원회 구성 현황';
      case '4': return '노사협의체 구성 현황';
      case '5': return '안전보건 예산 현황';
      case '6': return '안전보건 교육';
      case '7': return '종사자 의견 청취 현황';
      case '8': return '위험요인 파악 현황';
      case '9': return '정기 위험성평가 현황';
      case '10': return '수시 위험성평가 현황';
      case '11': return '작업장 합동점검 현황';
      case '12': return '안전보건 점검 현황';
      case '13': return '비상대피 훈련 현황';
      case '14': return '중대재해 발생 현황';
      case '15': return '안전보건 예산 집행률 현황';
      case '16': return '시설물 점검 현황';
      case '17': return '시설물 진단 현황';
      case '18': return '시설물 보수 현황';
      case '19': return '시설물 보강 현황';
      case '20': return '시설물 교체 현황';
      default: return '';
      }
    },
    getComponent() {
      let nId = this.graphId;

      // 만약 nId 값이 숫자로만 구성되어 있다면, 0을 왼쪽에 붙여서 2자리 숫자로 만들어준다.
      if (typeof nId === 'string') {
        if (nId.length === 1) {
          nId = `0${  nId}`;
        }
      } else if (typeof nId === 'number') {
        nId = nId.toString();
        if (nId.length === 1) {
          nId = `0${  nId}`;
        }
      }

      // console.log('fdcxvdfds', nId, typeof nId, this.$options.components[`GraphDetail${nId}`]);
      if (this.$options.components[`GraphDetail${nId}`]) return `GraphDetail${nId}`;
      else if (this.$options.components[`${nId}`]) return `${nId}`;
      else return "GraphDetailNone";
    },
    comGroupList() {
      const companyTree = this.$store.state.company.companyTree;
      let maxDepth = 0;
      const list = {};
      let hasRootHead = false;
      const headList = [];

      if (companyTree.length > 0) {
        for (const com of companyTree) {
          if (!com || !com.descendant) {
            continue;
          }

          if (typeof com.descendant !== "undefined" && com.descendant.com_type === "head") {
            hasRootHead = true;
            headList.push(com.descendant.com_name);
          }
          if (com.depth > maxDepth) {
            maxDepth = com.depth;
          }

          const parentId = com.descendant.parent_id ? com.descendant.parent_id : com.descendant.id;
          //const com_name =
          if (list[`com_${parentId}`]) {
            list[`com_${parentId}`][com.descendant.id] = com.descendant.com_name;
          } else {
            list[`com_${parentId}`] = { [com.descendant.id]: com.descendant.com_name };
          }
        }
      }

      return {
        maxDepth,
        hasRootHead,
        headList,
        list,
      };
    },
    graphId() {
      return this.$route.params.graphId;
    },
    projectList() {
      const list = this.$store.state.project.projectListInfo.data;
      const projectList = [];
      if (list && list.length > 0) {
        for (const proj of list) {
          projectList.push(proj.field_name);
        }
      }
      return projectList;
    },
  },
  methods: {
    async loadCompanyList() {
      const page = 1;
      const perPage = 10000;
      const projectId = this.projectId;
      await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId });
      await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
        page,
        perPage,
        comType: "head",
        projectId,
      });
    },
  },
};
</script>

<style lang="scss">
[dir] .vx-card.graph2 .vx-card__collapsible-content .vx-card__body {
  padding: 0 0 1.5rem 0;
}
</style>
